import { createApiClient, createRememberStorage } from "@studyward/shared";
import { createClient } from "@supabase/supabase-js";
import { apiBaseUrl, env, isConfigured } from "./env";

export const authStorage = createRememberStorage("sw-web");

/**
 * Browser Supabase client (anon key + RLS). PKCE: email links and OAuth return a `code` that the client exchanges
 * on /auth/callback. Sessions are stored per origin, so the student session never reaches admin (§4.4).
 */
export const supabase = createClient(isConfigured ? env.supabaseUrl : "http://localhost:54321", isConfigured ? env.supabaseAnonKey : "unset", {
  auth: {
    flowType: "pkce",
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    storage: authStorage.storage,
    storageKey: "sw-web-auth",
  },
});

export const api = createApiClient({
  baseUrl: apiBaseUrl,
  apiKey: env.supabaseAnonKey,
  surface: "web",
  getAccessToken: async () => (await supabase.auth.getSession()).data.session?.access_token ?? null,
});
